<template>
<div class="editnotification-container">
    <div class="top">

        <div class="fields">
            <div class="field" >
                <p>Tipo CTA</p>
                <vs-select v-model="notification.call_to_action_type">
                    <vs-option label="Nessuna" value="None">
                        Nessuna
                    </vs-option>
                    <vs-option label="URL" value="URL">
                        URL
                    </vs-option>
                </vs-select>
            </div>
            <div class="field">
                <p>CTA</p>
                <vs-input
                  type="text"
                  v-model="notification.call_to_action_value"
                  :disabled="notification.call_to_action_type !== 'URL'"
                  placeholder="es /blog, un URL completo"
                />
            </div>
            <small v-if="notification.call_to_action_type === 'URL'" class="hint">Inserisci un percorso interno (es. /blog).</small>

            <div class="field">
                <p>Default</p>
                <vs-checkbox v-model="notification.retroactive" />
            </div>
            <!-- Push Settings -->
            <div class="field" :style="{pointerEvents: isPushReadOnly ? 'none' : 'auto', opacity: isPushReadOnly ? 0.6 : 1}">
                <p>Invia push</p>
                <vs-checkbox v-model="notification.push_settings.send"  />
            </div>
            <div class="field" :style="{pointerEvents: isPushReadOnly ? 'none' : 'auto', opacity: isPushReadOnly ? 0.6 : 1}">
                <p>Destinatari</p>
                <vs-select multiple placeholder="Seleziona destinatari" v-model="audienceSelection" @input="onAudienceChange" >
                    <vs-option label="Tutti (global)" :value="'global'">Tutti (global)</vs-option>
                    <vs-option label="Solo Premium" :value="'premium'">Solo Premium</vs-option>
                    <vs-option label="Amministratore" :value="'administrator'">Amministratore</vs-option>
                    <vs-option label="Partner" :value="'partner'">Partner</vs-option>
                    <vs-option label="Utenti in prova" :value="'user_with_free_trial'">Utenti in prova</vs-option>
                    <vs-option label="Prova scaduta" :value="'user_with_expired_trial'">Prova scaduta</vs-option>
                </vs-select>
            </div>

            <template v-if="notification.localized != null">
                <div v-for="l in notification.localized" :key="'lang-' + l.language_id">
                    <div class="field">
                        <p>Titolo [{{ languages.find(e => e.id == l.language_id).name }}]</p>
                        <vs-input type="text" v-model="l.title" />
                    </div>
                    <div class="field">
                        <p>Contenuto [{{ languages.find(e => e.id == l.language_id).name }}]</p>
                        <vs-input type="text" v-model="l.text" />
                    </div>
                </div>
            </template>

            <vs-button v-if="notification.id == null" size="large" :loading="loading" @click="editNotificationEvent">{{ $t('common.saveChanges').toUpperCase() }}</vs-button>
            <vs-button v-if="notification.id != null" size="large" :loading="loading" @click="editNotificationEvent">{{ $t('common.saveChanges').toUpperCase() }}</vs-button>
            <vs-button v-if="notification.id != null" danger border size="large" :loading="deleting" @click="deleteNotificationEvent">{{ $t('common.delete').toUpperCase() }}</vs-button>

        </div>
    </div>

</div>
</template>

<script>
import {
    apiCall,
    baseUri
} from '../../utils/ApiMiddleware';
export default {
    name: "editnotification",
    props: {
        notification: {
            type: Object,
            required: true
        },
        editNotification: {
            type: Function,
            required: true
        },

        user: {
            type: Object,
            required: false,
            default: null
        },

        deleted: {
            type: Function,
            required: true
        }
    },
    components: {},
    data() {
        return {
            loading: false,
            languages: [],
            lang: null,
            baseUri,
            deleting: false,
            audienceSelection: [],
        }
    },
    computed: {
        isPushReadOnly() {
            const id = this.notification ? this.notification.id : null;
            if (id === null || id === undefined) return false;
            if (typeof id === 'number') return id > 0;
            if (typeof id === 'string') {
                const t = id.trim();
                if (t === '' || t === '0' || t.toLowerCase() === 'null' || t.toLowerCase() === 'undefined') return false;
                const n = parseInt(t, 10);
                if (!isNaN(n)) return n > 0;
                // Non-numeric string (e.g. UUID) -> treat as persisted
                return true;
            }
            return !!id;
        }
    },

    async mounted() {
        const response = await apiCall('GET', '/users/languages');
        if (response.status != 200) {
            this.$vs.notification({
                color: 'danger',
                position: 'top-right',
                title: this.$t('common.messages.somethingWentWrong'),
                text: 'Impossibile ottenere le lingue'
            })
            return;
        }
        this.languages = response.data.language;
        this.lang = this.languages.find(e => e.id == this.user.language.id).id

        if (this.notification.id == null) {
            this.notification.localized = this.languages.map(e => ({
                language_id: e.id,
                text: '',
                title: ''
            }))
        }
        if(this.notification.call_to_action_type == null || this.notification.call_to_action_type == ''){
            this.notification.call_to_action_type = 'None';
        }
        if (!this.notification.push_settings) {
            this.$set(this.notification, 'push_settings', {
                send: !!this.notification.send,
                global: !!this.notification.global,
                premium: !!this.notification.premium,
                administrator: !!this.notification.administrator,
                partner: !!this.notification.partner,
                user_with_free_trial: !!this.notification.user_with_free_trial,
                user_with_expired_trial: !!this.notification.user_with_expired_trial
            });
        }
        this.syncAudienceSelectionFromPush();
    },

    methods: {

        async deleteNotificationEvent() {
            this.deleting = true;
            const response = await apiCall('DELETE', '/backoffice/notifications/' + this.notification.id);
            this.deleting = false;
            // if status code is 200, show a success message 
            if (response.status == 200) {
                this.$vs.notification({
                    title: this.$t('common.messages.success'),
                    text: 'Notifica eliminata con successo',
                    color: 'success',
                    position: 'top-right'
                });
                this.deleted();
            } else if (response.status != 0) {
                this.$vs.notification({
                    title: this.$t('common.messages.somethingWentWrong'),
                    text: 'Impossibile eliminare la notifica',
                    color: 'danger',
                    position: 'top-right'
                });
            }

        },

        async editNotificationEvent() {

            this.loading = true;
            try {
                var temp = JSON.parse(JSON.stringify(this.notification));
                if (temp.call_to_action_type == 'None') {
                    temp.call_to_action_value = '';
                }

                // Ensure push_settings exists
                if (!temp.push_settings) {
                    temp.push_settings = {
                        send: false,
                        global: false,
                        premium: false,
                        administrator: false,
                        partner: false,
                        user_with_free_trial: false,
                        user_with_expired_trial: false
                    };
                }

                // Validation rules
                if (temp.push_settings.send) {
                    const targets = ['global', 'premium', 'administrator', 'partner', 'user_with_free_trial', 'user_with_expired_trial'];
                    const selected = targets.filter(k => temp.push_settings[k]);

                    if (selected.length === 0) {
                        this.$vs.notification({
                            title: this.$t('common.messages.somethingWentWrong'),
                            text: 'Se invii una push, seleziona almeno un destinatario',
                            color: 'warning',
                            position: 'top-right'
                        });
                        return;
                    }

                    if (temp.push_settings.global && selected.length > 1) {
                        this.$vs.notification({
                            title: this.$t('common.messages.somethingWentWrong'),
                            text: 'Con "Tutti (global)" non puoi selezionare altri destinatari',
                            color: 'warning',
                            position: 'top-right'
                        });
                        return;
                    }
                }

                // Keep audience flags even when push is disabled:
                // - This allows targeting to be configured for non-push notifications too
                // - Validation above only enforces selection when push send is enabled

                // Normalize CTA URL: if absolute URL points to current origin, strip origin and keep only URI
                if (temp.call_to_action_type === 'URL' && typeof temp.call_to_action_value === 'string') {
                    temp.call_to_action_value = this.normalizeCtaUrl(temp.call_to_action_value);
                }

                // Flatten audience fields to root-level for API payload, but keep 'send' nested in push_settings
                if (temp.push_settings) {
                    const ps = temp.push_settings;
                    temp.global = !!ps.global;
                    temp.premium = !!ps.premium;
                    temp.administrator = !!ps.administrator;
                    temp.partner = !!ps.partner;
                    temp.user_with_free_trial = !!ps.user_with_free_trial;
                    temp.user_with_expired_trial = !!ps.user_with_expired_trial;

                    // keep only 'send' under push_settings
                    temp.push_settings = { send: !!ps.send };
                }

                await this.editNotification(temp);
            } finally {
                this.loading = false;
            }

        },
        syncAudienceSelectionFromPush() {
            const ps = this.notification.push_settings || {};
            const selected = [];
            if (ps.global) selected.push('global');
            if (ps.premium) selected.push('premium');
            if (ps.administrator) selected.push('administrator');
            if (ps.partner) selected.push('partner');
            if (ps.user_with_free_trial) selected.push('user_with_free_trial');
            if (ps.user_with_expired_trial) selected.push('user_with_expired_trial');
            this.audienceSelection = selected;
        },
        applyAudienceSelectionToPush() {
            const keys = ['global','premium','administrator','partner','user_with_free_trial','user_with_expired_trial'];
            keys.forEach(k => { this.notification.push_settings[k] = this.audienceSelection.includes(k); });
        },
        onAudienceChange(val) {
            // Enforce exclusivity: if 'global' is selected, it's the only one
            if (!Array.isArray(val)) {
                this.audienceSelection = [];
            } else if (val.includes('global') && val.length > 1) {
                this.audienceSelection = ['global'];
            } else if (!val.includes('global')) {
                this.audienceSelection = val;
            } else {
                this.audienceSelection = ['global'];
            }
            this.applyAudienceSelectionToPush();
        },

        // Normalize CTA URL input:
        // - If user pasted an absolute URL to the current origin (e.g. https://tourial.it/foo?x=1#y),
        //   return only the URI (/foo?x=1#y).
        // - If it's already relative, or it points to another domain (e.g. YouTube), return as-is.
        normalizeCtaUrl(value) {
            if (value == null) return value;
            const raw = String(value).trim();
            if (raw === '') return raw;
            try {
                const currentOrigin = (typeof window !== 'undefined' && window.location && window.location.origin)
                    ? window.location.origin.replace(/\/$/, '')
                    : '';
                // Detect absolute URLs like https://example.com/... or //example.com/...
                const isAbsolute = /^([a-z][a-z\d+\-.]*:)?\/\//i.test(raw) || /^[a-z][a-z\d+\-.]*:/.test(raw);
                // new URL allows resolving relative paths against current origin for uniform parsing
                const url = new URL(raw, currentOrigin || 'http://localhost');
                if (isAbsolute && currentOrigin && url.origin.replace(/\/$/, '') === currentOrigin) {
                    const path = url.pathname || '/';
                    const qs = url.search || '';
                    const hash = url.hash || '';
                    return path + qs + hash;
                }
                // Already relative or external domain
                return raw;
            } catch (e) {
                // If parsing fails, keep original input
                return raw;
            }
        },

    }
}
</script>

<style scoped>
.header {
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;

}

.top {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.fields {
    display: flex;
    flex-direction: column;
}

.field {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 30px;
    border-bottom: 1px solid var(--grey-75);
}

.field p {
    width: 35%;
    max-width: 35%;
}

.editnotification-container {

    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 20px;
    height: calc(100% - 75px);

    justify-content: space-between;
}

/* MOBILE */
@media (max-width: 600px) {
    .editnotification-container {
        padding-left: 20px;
        padding-right: 20px;
        padding-top: 20px;
        box-sizing: border-box;

    }

}

textarea {
    border-radius: 5px;
    border: 1px solid var(--grey-75);
    height: 150px;
    max-height: 150px;
    padding: 10px;
    font-family: Poppins;
}
</style><style>
.editnotification-container .field .vs-input {
    background: transparent !important;
    font-size: 1rem;
}

.editnotification-container .field .vs-select__input {
    background: transparent !important;
    font-size: 1rem;
}

.editnotification-container .field input::-webkit-date-and-time-value {
    text-align: left !important;
    font-size: 1rem;
}

.editnotification-container .hint {
    color: var(--grey-600, #666);
    font-size: 0.875rem;
    margin: 6px 0 12px 35%;
}
</style>
